<template>
  <ModalCardDefault
    :title="'Clientes'"
    @close="$emit('update:dialogModal', false)"
  >
    <ExpansionPanel
      v-model="panel"
      :title="'Lista de Todos os Clientes'"
      :icon="$icons.box"
      readonly
    >
      <DataTable
        ref="clientsDataTable"
        no-sync
        :items="clients"
        :headers="headers"
        :slots="slots"
        show-select
        single-select
        :loading="loading"
        @setSelected="setSelected"
      >
        <template v-slot:custom-header>
          <TextFieldSimpleMask
            v-model="document"
            label="CPF"
            placeholder="Digite o CPF"
            clearable
            :inputMask="masks.cpf"
            outputMask="###########"
          />
        </template>

        <template v-slot:name="{ props: { item } }">
          {{ item.name }}
        </template>
      </DataTable>
    </ExpansionPanel>

    <template v-slot:actions>
      <Button color="secondary" rounded @click="confirm" class="mr-3">
        <span class="text-button"
          >Confirmar
          <span class="text-button font-weight-black yellow--text"
            >(Enter)</span
          >
        </span>
      </Button>
    </template>
  </ModalCardDefault>
</template>

<script>
import {
  DataTable,
  Button,
  ExpansionPanel,
  TextFieldSimpleMask,
} from '@/components/vuetify';
import ModalCardDefault from '@/components/ModalCardDefault';
import InputFocusMixin from '@/mixins/InputFocusMixin';
import { cpf } from '@/utils/masks';

export default {
  name: 'PdvClients',
  components: {
    ModalCardDefault,
    DataTable,
    Button,
    ExpansionPanel,
    TextFieldSimpleMask,
  },
  data() {
    return {
      panel: [0],
      slots: [
        { field: 'name' },
        { cell_phone_formatted: 'cell_phone_formatted' },
      ],
      clients: [],
      selected: null,
      loading: false,
      document: '',
      masks: {
        cpf,
      },
    };
  },
  created() {
    window.addEventListener('keydown', this.actionListener);
  },
  destroyed() {
    window.removeEventListener('keydown', this.actionListener);
  },
  computed: {
    headers() {
      return [
        { text: 'Nome', value: 'name' },
        { text: 'Estado', value: 'address.uf' },
        { text: 'Cidade', value: 'address.city' },
        { text: 'Fone', value: 'cell_phone_formatted' },
      ];
    },
  },
  mixins: [InputFocusMixin],
  methods: {
    getClients() {
      this.loading = true;
      this.$api.registers
        .filters({
          url: 'filters?domain=register&filter[type]=client&page=1&per_page=-1',
        })
        .then(({ data: { registers } }) => {
          this.clients = registers;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setSelected(item) {
      this.selected = item[0];
    },
    confirm() {
      if (!this.selected && !this.document) {
        this.$noty.error('Selecione um Cliente ou Digite um CPF');

        return;
      }
      this.$emit('confirmDialog', {
        action: 'setClient',
        data: {
          ...this.selected,
          document: this.document,
          only_document: !!this.document,
        },
      });
    },
    actionListener(event) {
      if (event.key === 'Enter') {
        this.confirm();
      }
    },
  },
  mounted() {
    this.getClients();
    this.focusInputs(
      this.$refs.clientsDataTable.$refs.searchDataTable.$refs.inputDataTable
    );
  },
};
</script>
